import { Alert, AlertIcon } from "@chakra-ui/react";
import { InputDatePicker } from "@components/ui-kit";
import { t } from "@lingui/macro";
import type { FieldState } from "formstate";
import { observer } from "mobx-react-lite";

interface FooterFormProps {
  validFrom: FieldState<Date | undefined>;
}

const FooterForm = ({ validFrom }: FooterFormProps) => (
  <div className="w-1/3">
    <div className="flex items-center">
      <label className="w-2/3 text-right pr-6" htmlFor="valid_from">
        {t`Assign to project at date`}
      </label>
      <div className="w-1/3">
        <InputDatePicker
          id="valid_from"
          selected={validFrom.value}
          error={!!validFrom.error}
          onChange={(range) => validFrom.onChange(range?.start)}
        />
      </div>
    </div>
    <div className="w-1/3 ml-auto mt-2">
      {validFrom.hasError && (
        <Alert status="error">
          <AlertIcon />
          {validFrom.error}
        </Alert>
      )}
    </div>
  </div>
);

export default observer(FooterForm);
